if (!customElements.get('delivery-urgency')) {
    let _urgencyDeliveryCfg = null;
    function getUrgencyDeliveryCfg() {
        if (_urgencyDeliveryCfg) return _urgencyDeliveryCfg;
        try {
            const el = document.getElementById('GiftingOptionsData');
            _urgencyDeliveryCfg = (el ? JSON.parse(el.textContent) : {}).delivery || {};
        } catch (e) { _urgencyDeliveryCfg = {}; }
        return _urgencyDeliveryCfg;
    }

    function isBlockedSunday(date) {
        if (date.getDay() !== 0) return false;
        const cfg = getUrgencyDeliveryCfg();
        if (!cfg.sunday_exception_enabled || !cfg.sunday_exception_date) return true;
        const ex = new Date(cfg.sunday_exception_date + 'T00:00:00');
        return !(date.getFullYear() === ex.getFullYear() &&
                 date.getMonth() === ex.getMonth() &&
                 date.getDate() === ex.getDate());
    }

    class DeliveryUrgency extends HTMLElement {
        constructor() {
            super();
            this.cutoffHour = parseInt(this.dataset.cutoffHour) || 19;
            this.cutoffMinute = parseInt(this.dataset.cutoffMinute) || 0;
            this.beforeMessage = this.dataset.beforeMessage || "Order within {timer} for delivery tomorrow";
            this.afterMessage = this.dataset.afterMessage || "Order now for delivery on {earliest_date}";
            this.showDeliveryDate = this.dataset.showDeliveryDate !== 'false';
            this.dateFormat = this.dataset.dateFormat || 'long';
            this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';
            this.timerEl = this.querySelector('.delivery-urgency__timer');
            this.dateEl = this.querySelector('.delivery-urgency__earliest-date');
            this.deliveryDateEl = this.querySelector('.delivery-urgency__delivery-date');
            this.textWrapper = this.querySelector('.delivery-urgency__text');

            this.init();
        }

        init() {
            if (this.timerEl) {
                this.startTimer();
            }
            if (this.dateEl) {
                this.updateEarliestDate();
            }
            if (this.deliveryDateEl) {
                this.updateDeliveryDate();
            }
        }

        getSydneyTime() {
            // Returns a Date object set to the current time in Sydney
            return new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
        }

        getDateFormatOptions() {
            const formats = {
                'short': { weekday: 'short', month: 'short', day: 'numeric' },
                'medium': { weekday: 'long', month: 'long', day: 'numeric' },
                'long': { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }
            };
            return formats[this.dateFormat] || formats['long'];
        }

        startTimer() {
            const update = () => {
                const now = this.getSydneyTime();
                const cutoff = this.getSydneyTime();
                cutoff.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);

                const diff = cutoff - now;

                if (diff <= 0) {
                    if (this.hideWhenExpired) {
                        this.style.display = 'none';
                        if (this.timerInterval) clearInterval(this.timerInterval);
                        return;
                    }

                    this.removeAttribute('data-before-cutoff');
                    // Switch to after cutoff message
                    if (this.textWrapper) {
                        const earliestDate = this.getEarliestDateString();
                        let message = this.afterMessage;
                        if (this.showDeliveryDate && message.includes('{earliest_date}')) {
                            message = message.replace('{earliest_date}', `<span class="delivery-urgency__earliest-date">${earliestDate}</span>`);
                        } else if (this.showDeliveryDate && !message.includes('{earliest_date}')) {
                            message += ` <span class="delivery-urgency__earliest-date">${earliestDate}</span>`;
                        } else {
                            message = message.replace('{earliest_date}', '');
                        }
                        this.textWrapper.innerHTML = message;
                        this.dateEl = this.querySelector('.delivery-urgency__earliest-date');
                    }
                    if (this.timerInterval) clearInterval(this.timerInterval);
                    // Start date update interval if needed
                    if (this.dateEl && this.showDeliveryDate) {
                        this.dateInterval = setInterval(() => this.updateEarliestDate(), 60000); // Update every minute
                    }
                    return;
                }

                const h = Math.floor(diff / 3600000);
                const m = Math.floor((diff % 3600000) / 60000);
                const s = Math.floor((diff % 60000) / 1000);

                this.timerEl.textContent = `${h}h ${m}m ${s}s`;
            };

            update();
            this.timerInterval = setInterval(update, 1000);
        }

        getEarliestDateString() {
            const now = this.getSydneyTime();
            const cutoff = this.getSydneyTime();
            cutoff.setHours(this.cutoffHour, this.cutoffMinute, 0, 0);

            let earliest = this.getSydneyTime();
            if (now >= cutoff) {
                earliest.setDate(earliest.getDate() + 2);
            } else {
                earliest.setDate(earliest.getDate() + 1);
            }

            // Skip Sundays unless it's an exception like Mother's Day
            if (isBlockedSunday(earliest)) {
                earliest.setDate(earliest.getDate() + 1);
            }

            return earliest.toLocaleDateString('en-AU', this.getDateFormatOptions());
        }

        updateEarliestDate() {
            if (!this.dateEl || !this.showDeliveryDate) return;
            this.dateEl.textContent = this.getEarliestDateString();
        }

        getDeliveryDateString() {
            const now = this.getSydneyTime();
            let delivery = this.getSydneyTime();
            delivery.setDate(delivery.getDate() + 1);

            // Skip Sundays unless it's an exception like Mother's Day
            if (isBlockedSunday(delivery)) {
                delivery.setDate(delivery.getDate() + 1);
            }

            const tomorrow = this.getSydneyTime();
            tomorrow.setDate(tomorrow.getDate() + 1);

            // If it's Monday but tomorrow is Sunday, return the full date string
            // Otherwise if it's still tomorrow, return "tomorrow"
            if (delivery.getDate() === tomorrow.getDate() && delivery.getMonth() === tomorrow.getMonth()) {
                return "tomorrow";
            }

            return delivery.toLocaleDateString('en-AU', this.getDateFormatOptions());
        }

        updateDeliveryDate() {
            if (!this.deliveryDateEl || !this.showDeliveryDate) return;
            this.deliveryDateEl.textContent = this.getDeliveryDateString();
        }

        disconnectedCallback() {
            if (this.timerInterval) clearInterval(this.timerInterval);
            if (this.dateInterval) clearInterval(this.dateInterval);
        }
    }

    customElements.define('delivery-urgency', DeliveryUrgency);
}
